
import React from 'react';

import SFIndex from "@dndComponents/SFIndex";

export default function StandardFeaturesIndex() {
  return (
    <SFIndex />
  );
}
